export default __webpack_public_path__ + "static/media/vote.6c378dd9.svg";